import AOS from 'aos';
//import 'aos/dist/aos.css'; */

import "./js/main";
import Numbers from "./js/numbers";

Numbers.init();

document.addEventListener("DOMContentLoaded", function() {
    AOS.init({
        once: true,
        startEvent: 'DOMContentLoaded'
    });
});


